/**
 * The address bar is a section and, after a question mark, what to do there.
 *
 * `#people?user=sam%40lopie.dev&tag=finance` is the People screen, opened with
 * a grant for that person and that tag ready to confirm. The section is
 * everything before the `?`, so a link with parameters still names a section
 * and the shell does not take it for one that does not exist.
 *
 * No router: this is the same deep link the shell has always had, with a
 * query on the end that only the section it names reads.
 */
export function parseHash(hash) {
  const raw = String(hash ?? "").replace(/^#/, "");
  const at = raw.indexOf("?");
  const id = at === -1 ? raw : raw.slice(0, at);
  const query = at === -1 ? "" : raw.slice(at + 1);
  return { id, params: new URLSearchParams(query) };
}

/** Takes the parameters off the address once a section has read them, so a
 *  reload or a copied link does not repeat what they asked for. */
export function clearHashParams() {
  const { id } = parseHash(window.location.hash);
  window.history.replaceState(null, "", `${window.location.pathname}${window.location.search}#${id}`);
}
